import type { MucDo } from './types.ts';

/**
 * Danh mục mã hành động của giao diện — bản chiếu của `libs/audit-catalog/danh-muc/v1.json` (78 mã, ADR-0095 mục 2).
 *
 * ── VÌ SAO KHÔNG IMPORT THẲNG `v1.json` ──────────────────────────────────
 * Native import tệp JSON của gói danh mục. Ở platform, image web build bằng `web/Dockerfile` chỉ `COPY web` (không có
 * `libs/`), nên `import '../../../../../../libs/audit-catalog/danh-muc/v1.json'` chạy được ở máy dev nhưng VỠ build
 * image — đúng kiểu "test pass, prod lỗi". `libs/audit-catalog/README.md` cũng chốt: giao diện không đọc tệp ấy.
 *
 * Nên giao diện giữ hai thứ của danh mục:
 * - **câu** của từng mã ở hai catalog dịch (`i18n/messages/nhat-ky-truy-vet/chung.{vi,en}.ts`, khoá `nktvDanhMuc`);
 * - **biểu tượng và mức độ mặc định** ở bảng dưới đây (không dịch).
 *
 * `danh-muc-khop.test.ts` đọc `v1.json` bằng `node:fs` (chỉ test, không vào bundle) và đòi: đúng tập mã, đúng
 * `bieu_tuong`/`muc_do`, câu tiếng Việt trùng từng ký tự, câu tiếng Anh cùng bộ placeholder. Thêm mã ở `libs/` mà quên
 * ở đây là bài test đỏ.
 */
export const DANH_MUC = {
  'xac_thuc.dang_nhap': { bieu_tuong: 'vao', muc_do: 'thong_tin' },
  'xac_thuc.dang_nhap_that_bai': { bieu_tuong: 'canh_bao', muc_do: 'quan_trong' },
  'xac_thuc.dang_xuat': { bieu_tuong: 'ra', muc_do: 'thong_tin' },
  'nguoi_dung.tao': { bieu_tuong: 'nguoi_moi', muc_do: 'quan_trong' },
  'nguoi_dung.khoa': { bieu_tuong: 'khoa', muc_do: 'nhay_cam' },
  'nguoi_dung.doi_quyen': { bieu_tuong: 'khoa', muc_do: 'nhay_cam' },
  'van_ban.tao': { bieu_tuong: 'tao', muc_do: 'thong_tin' },
  'van_ban.sua': { bieu_tuong: 'sua', muc_do: 'thong_tin' },
  'van_ban.trinh': { bieu_tuong: 'trinh', muc_do: 'quan_trong' },
  'van_ban.ky': { bieu_tuong: 'ky', muc_do: 'quan_trong' },
  'van_ban.ban_hanh': { bieu_tuong: 'ban_hanh', muc_do: 'quan_trong' },
  'van_ban.thu_hoi': { bieu_tuong: 'hoan_tac', muc_do: 'nhay_cam' },
  'van_ban.xoa': { bieu_tuong: 'xoa', muc_do: 'nhay_cam' },
  'ho_so.xem': { bieu_tuong: 'xem', muc_do: 'thong_tin' },
  'du_lieu.xuat': { bieu_tuong: 'xuat', muc_do: 'nhay_cam' },
  'chung_tu.ocr': { bieu_tuong: 'quet', muc_do: 'thong_tin' },
  'chung_tu.doi_chieu': { bieu_tuong: 'doi_chieu', muc_do: 'thong_tin' },
  'llm.goi': { bieu_tuong: 'ai', muc_do: 'thong_tin' },
  'cau_hinh.sua': { bieu_tuong: 'banh_rang', muc_do: 'nhay_cam' },
  'bang_gia.sua': { bieu_tuong: 'tien', muc_do: 'nhay_cam' },
  'ty_gia.sua': { bieu_tuong: 'tien', muc_do: 'nhay_cam' },
  'han_muc.sua': { bieu_tuong: 'dong_ho', muc_do: 'nhay_cam' },
  'han_muc.canh_bao': { bieu_tuong: 'canh_bao', muc_do: 'quan_trong' },
  'han_muc.vuot': { bieu_tuong: 'canh_bao', muc_do: 'quan_trong' },
  'han_muc.chan': { bieu_tuong: 'canh_bao', muc_do: 'quan_trong' },
  'han_muc_ai.chan': { bieu_tuong: 'canh_bao', muc_do: 'quan_trong' },
  'chi_phi.dieu_chinh': { bieu_tuong: 'tien', muc_do: 'nhay_cam' },
  'nhat_ky.xem': { bieu_tuong: 'xem', muc_do: 'nhay_cam' },
  'nhat_ky.xuat': { bieu_tuong: 'xuat', muc_do: 'nhay_cam' },
  'nhat_ky.luu_tru': { bieu_tuong: 'kho', muc_do: 'nhay_cam' },
  'nhat_ky.sai_lech_toan_ven': { bieu_tuong: 'canh_bao', muc_do: 'nhay_cam' },
  'canh_bao.phat': { bieu_tuong: 'canh_bao', muc_do: 'quan_trong' },
  'canh_bao.xu_ly': { bieu_tuong: 'xong', muc_do: 'quan_trong' },
  'canh_bao.sua_quy_tac': { bieu_tuong: 'banh_rang', muc_do: 'nhay_cam' },
  'danh_muc.tao': { bieu_tuong: 'muc_luc', muc_do: 'thong_tin' },
  'danh_muc.sua': { bieu_tuong: 'muc_luc', muc_do: 'thong_tin' },
  'danh_muc.xoa': { bieu_tuong: 'xoa', muc_do: 'nhay_cam' },
  'bo_tieu_chi.tao': { bieu_tuong: 'tao', muc_do: 'thong_tin' },
  'bo_tieu_chi.sua': { bieu_tuong: 'sua', muc_do: 'thong_tin' },
  'bo_tieu_chi.luu_nhap': { bieu_tuong: 'nhap', muc_do: 'thong_tin' },
  'bo_tieu_chi.phat_hanh': { bieu_tuong: 'ban_hanh', muc_do: 'quan_trong' },
  'bo_tieu_chi.cap_duyet': { bieu_tuong: 'khoa', muc_do: 'nhay_cam' },
  'bo_tieu_chi.chay_thu': { bieu_tuong: 'thu', muc_do: 'thong_tin' },
  'bo_tieu_chi.ai_goi_y': { bieu_tuong: 'ai', muc_do: 'thong_tin' },
  'bo_tieu_chi.ai_can_trong_so': { bieu_tuong: 'ai', muc_do: 'thong_tin' },
  'bo_tieu_chi.xoa': { bieu_tuong: 'xoa', muc_do: 'nhay_cam' },
  'tham_dinh.tao': { bieu_tuong: 'tao', muc_do: 'thong_tin' },
  'tham_dinh.nop_lai': { bieu_tuong: 'trinh', muc_do: 'quan_trong' },
  'tham_dinh.sua_ket_qua': { bieu_tuong: 'sua', muc_do: 'quan_trong' },
  'tham_dinh.cham_lai': { bieu_tuong: 'lam_lai', muc_do: 'quan_trong' },
  'tham_dinh.hoan_tat': { bieu_tuong: 'xong', muc_do: 'quan_trong' },
  'tham_dinh.phe_duyet': { bieu_tuong: 'ky', muc_do: 'quan_trong' },
  'tham_dinh.tra_lai': { bieu_tuong: 'hoan_tac', muc_do: 'quan_trong' },
  'tham_dinh.xuat_bien_ban': { bieu_tuong: 'xuat', muc_do: 'quan_trong' },
  'tham_dinh.ai_viet_lai': { bieu_tuong: 'ai', muc_do: 'quan_trong' },
  'tham_dinh.quyet_goi_y': { bieu_tuong: 'ai', muc_do: 'quan_trong' },
  'tham_dinh.ap_dung_sua': { bieu_tuong: 'ai', muc_do: 'quan_trong' },
  'tham_dinh.xoa': { bieu_tuong: 'xoa', muc_do: 'nhay_cam' },
  'khoa_api.tao': { bieu_tuong: 'khoa', muc_do: 'nhay_cam' },
  'khoa_api.sua_webhook': { bieu_tuong: 'moc_noi', muc_do: 'nhay_cam' },
  'khoa_api.thu_webhook': { bieu_tuong: 'thu', muc_do: 'thong_tin' },
  'khoa_api.thu_hoi': { bieu_tuong: 'hoan_tac', muc_do: 'nhay_cam' },
  'chung_tu.tao': { bieu_tuong: 'tao', muc_do: 'thong_tin' },
  'chung_tu.sua': { bieu_tuong: 'sua', muc_do: 'thong_tin' },
  'chung_tu.luu_nhap': { bieu_tuong: 'nhap', muc_do: 'thong_tin' },
  'chung_tu.ocr_lai': { bieu_tuong: 'lam_lai', muc_do: 'quan_trong' },
  'chung_tu.ocr_treo': { bieu_tuong: 'canh_bao', muc_do: 'quan_trong' },
  'chung_tu.canh_bao_kiem_tra': { bieu_tuong: 'canh_bao', muc_do: 'quan_trong' },
  'chung_tu.xac_nhan': { bieu_tuong: 'xong', muc_do: 'quan_trong' },
  'chung_tu.chuyen_kho': { bieu_tuong: 'kho', muc_do: 'quan_trong' },
  'chung_tu.xoa': { bieu_tuong: 'xoa', muc_do: 'nhay_cam' },
  'nhiem_vu.tao': { bieu_tuong: 'tao', muc_do: 'thong_tin' },
  'nhiem_vu.sua': { bieu_tuong: 'sua', muc_do: 'thong_tin' },
  'nhiem_vu.them_viec_con': { bieu_tuong: 'nhanh', muc_do: 'thong_tin' },
  'nhiem_vu.doi_nguoi_tham_gia': { bieu_tuong: 'nguoi_nhom', muc_do: 'quan_trong' },
  'nhiem_vu.doi_trang_thai': { bieu_tuong: 'co', muc_do: 'quan_trong' },
  'nhiem_vu.bao_tien_do': { bieu_tuong: 'phan_tram', muc_do: 'thong_tin' },
  'nhiem_vu.y_kien': { bieu_tuong: 'tin_nhan', muc_do: 'thong_tin' },
  'nhiem_vu.xoa': { bieu_tuong: 'xoa', muc_do: 'nhay_cam' },
} as const satisfies Record<string, { bieu_tuong: string; muc_do: MucDo }>;

/** Một mã đã khai trong danh mục — dạng `<doi_tuong>.<dong_tu>`. */
export type MaHanhDong = keyof typeof DANH_MUC;

export function coMa(ma: string): ma is MaHanhDong {
  return Object.prototype.hasOwnProperty.call(DANH_MUC, ma);
}

/** Mọi mã đã khai, sắp theo thứ tự chữ — nguồn của bộ lọc "Thao tác" khi chưa có danh mục khoảng. */
export function danhSachHanhDong(): MaHanhDong[] {
  return (Object.keys(DANH_MUC) as MaHanhDong[]).sort();
}

/** Tên biểu tượng của danh mục (`ky`, `khoa`, `ai`…), `null` khi mã chưa khai. Đổi ra icon ở `../bieu-tuong.ts`. */
export function bieuTuongCho(ma: string): string | null {
  return coMa(ma) ? DANH_MUC[ma].bieu_tuong : null;
}

/**
 * Mức độ mặc định của mã. Dùng để đọc danh mục (ví dụ bộ lọc), KHÔNG dùng để tô màu một dòng: dòng tô theo
 * `su_kien.muc_do` đã ghi — mức độ của bản ghi cũ là mức độ lúc ghi.
 */
export function mucDoCho(ma: string): MucDo | null {
  return coMa(ma) ? DANH_MUC[ma].muc_do : null;
}
